<template>
  <div class="draftcolumn">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "draftcolumn",
  props: {
    message: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      discussion: "",
    };
  },
};
</script>

<style lang="less" scoped>
.draftcolumn {
  width: 100%;
  height: 500px;
  background-color: rgb(255, 255, 255);
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/release/draftcolumn.vue